import React, { useState, useEffect } from "react";

interface TOCItem {
  id: string;
  text: string;
  level: number;
}

interface TableOfContentsProps {
  html: string;
}

const TableOfContents: React.FC<TableOfContentsProps> = ({ html }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [items, setItems] = useState<TOCItem[]>([]);

  useEffect(() => {
    // Parse HTML content to extract headings
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');
    
    const tocItems: TOCItem[] = Array.from(headings).map((heading) => {
      const level = parseInt(heading.tagName[1]);
      const text = heading.textContent || '';
      const id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      
      // Add id to the heading in the HTML
      heading.id = id;
      
      return { id, text, level };
    });

    setItems(tocItems);
  }, [html]);

  if (items.length === 0) return null;

  return (
    <div className="bg-white border border-neutral-200 rounded-lg p-4 w-full shadow-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-left font-semibold text-neutral-800 flex items-center justify-between"
      >
        <span>🧭 Sommaire</span>
        <span className="text-neutral-400">{isOpen ? "▲" : "▼"}</span>
      </button>
      
      {isOpen && (
        <ul className="mt-4 space-y-2 text-sm text-neutral-700">
          {items.map((item) => (
            <li 
              key={item.id} 
              style={{ paddingLeft: `${(item.level - 1) * 1}rem` }}
              className="hover:bg-neutral-50 rounded transition-colors"
            >
              <a 
                href={`#${item.id}`} 
                className="block py-1 px-2 hover:text-primary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(item.id)?.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                  });
                }}
              >
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TableOfContents;